module.exports = __webpack_public_path__ + "static/img/fgbg2-5.c3709db.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-5.png
// module id = 196
// module chunks = 0